module.exports = __webpack_public_path__ + "img/no-insights-activity.a3d2dcf3.webp";